<template>
    <div class="check-box">
        <div v-for="(item,index) in checkList.toHead" :key="index" class="check-box-item">
            <div class="check-label">{{item.label}}</div>
                <div v-for="(check,itemIndex) in checkList.data" :key="itemIndex" >
                  <div v-if="item.field === itemIndex">
                      
                       <span v-for="(every,indexCheck) in check" :key="indexCheck">
                           <span class="check-box-choice" @click="onselectionValue(item.label,itemIndex,index,every)" :class="actionids.find(_ => _.field === itemIndex && _.key === every && item.label === _.label ) ? 'active' : ''">{{every}}</span>
                       </span>
                  </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        // 数据集合
        checkList:{
            type: Object,
            default: function(){
                return {
                        toHead: [{
                            label: '地区',
                            field: 'address'
                        }],
                        data: {
                            address:['广东','深圳','中山','惠州']
                        }
                    }
                
            }
        },
        // 单选多选
        checked:{
            type: Boolean,
            default: function() {
                return false // 默认多选
            }
        }
    },
    data(){
        return {
            actionids: [] // 选择的集合
        }
    },
    watch:{
        checkList: function(v,r){
            console.log(v,r)
        }
    },
    methods:{
        // 点击
        onselectionValue(label,field,index,key){
                if(this.checked){
                  this.actionids[index].key = key
                  this.$forceUpdate()
                }else{
                    let find = this.actionids.findIndex(_ => _.field === field && _.label === label && key === _.key)
                        if(find == -1){
                        this.actionids.push({
                            key,
                            label,
                            field
                        })
                    }else{
                        this.actionids.splice(find,1)
                    }
                }
            this.$emit('successCheck',this.actionids,index)
        },
        init() {
            let that = this
            this.$nextTick(function(){
                        this.actionids = this.checkList.toHead.map(_ =>{
                            for (const [i,p] of Object.entries(this.checkList.data || {}) || {}) {
                                if(_.field === i){
                                    _.key = p[0] || ''
                                }
                            }
                            return _
                        })|| []  
            })
        }
    },
    mounted(){
        this.init()
    }
}
</script>
<style lang="less" scoped>
.check-box{
  .check-box-item{
      display: flex;
      font-size: 18px;
      margin-bottom: 3px;
      .check-box-choice,.check-label{
          padding: 8px 11px;
      }
      .check-box-choice{
          line-height: 43px;
         margin-right: 15px;
         cursor: pointer;
      }
      .check-label{
          height: 36px;
    }
      .check-box-choice:hover{
          color: #5088FCFF;
      }
  }
  .active{
      background:#5088FCFF;
      color:white
  }
  .active:hover{
      color:white !important;
  }
}
</style>